import { clearObject } from "@/functions/helpers";
import {
  SALE_STATUS_NAME_MAP,
  SALE_STATUS_BADGE_MAP,
  SALE_PAY_METHOD_NAME_MAP
} from "@/constants/sales.js";
import moment from "moment";
export default {
  data() {
    return {
      modal: {
        rePix: false,
        retry: false,
        billet: false,
        details: false,
        changeSubscription: false,
        addressConfirmation: false
      },
      completed: {
        modal: false,
        text: ""
      },
      filters: {
        product_id: "",
        status: ["paid", "completed"],
        payment_process: "",
        paid_at_after: "",
        paid_at_before: ""
      },
      loading: false
    };
  },
  filters: {
    formatDate(val) {
      if (val) val = val.replace("Z", "");
      return val ? moment(val).format("DD/MM/YYYY") : "-";
    },
    formatStatusName(status) {
      return SALE_STATUS_NAME_MAP[status];
    }
  },
  methods: {
    getStatusBadge(item) {
      return SALE_STATUS_BADGE_MAP[item.status];
    },
    getPayMethod(payment_method) {
      if (payment_method) {
        return SALE_PAY_METHOD_NAME_MAP[payment_method.toLowerCase()];
      }
      return "-";
    },
    refresh() {
      this.loading = true;
      const params = {
        ...this.filters,
        status: this.filters.status.join(","),
        search: this.search,
        offset: this.offset
      };
      this.$store
        .dispatch("sale/get", clearObject(params))
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    submitRefund(id) {
      this.$store
        .dispatch("sale/refund", id)
        .then(() => {
          this.completed.text = "O reembolso foi enviado com sucesso.";
          this.completed.modal = true;
          this.dispatch();
        })
        .catch(() => {
          this.$message.success("Erro ao enviar reembolso");
        });
    },
    cancelSubscription(id) {
      this.$store
        .dispatch("subscriptions/cancel", id)
        .then(() => {
          this.completed.text = "O cancelamento foi realizado com sucesso.";
          this.completed.modal = true;
        })
        .catch(() => {
          this.$message.error("Erro ao realizar cancelamento");
        });
    },
    extraActions(item) {
      const actions = [];
      if (
        this.$permissions.hasPermission("solicitar-reembolsos") &&
        this.allowRefund(item)
      ) {
        actions.push({
          label: "Reembolsar",
          class: "text-negative-600",
          icon: "fa-regular fa-money-bill-transfer",
          click: i => this.submitRefund(i.id),
          confirmation: {
            enable: true,
            text: `Deseja mesmo realizar o reembolso da transação: BP${item.id}?`
          },
          event: "refund"
        });
      }
      if (item.billet) {
        actions.push({
          label: "Abrir boleto",
          icon: "icon-bar-code font-weight-bold",
          click: i => this.showBillet(i)
        });
      } else if (item.payment_method === "pix" && item.status === "pending") {
        actions.push({
          label: "Reenviar pix",
          icon: "icon-pix",
          click: i => this.openRePix(i)
        });
      } else if (item.status === "failed") {
        actions.push({
          label: "Tentar novamente",
          icon: "icon-credit-card font-weight-bold",
          click: i => this.tryAgain(item)
        });
      }

      actions.push({
        label: "Comprovante",
        icon: "fa-solid fa-receipt pl-1",
        click: i => this.openReceipt(item)
      });

      if (item.charge_type === "signature" && item.status !== "failed") {
        if (this.$permissions.hasPermission("gerenciar-assinaturas")) {
          actions.push({
            label: "Configurar pagamento",
            icon: "icon-calendar font-weight-bold",
            click: i => this.changeSubscription(item.id)
          });
        }
        if (this.$permissions.hasPermission("cancelar-assinaturas")) {
          actions.push({
            label: "Cancelar assinatura",
            icon: "icon-x font-weight-bold",
            click: i => this.cancelSubscription(item.id),
            confirmation: {
              enable: true,
              text: `Deseja mesmo realizar o cancelamento da assinatura de ${item.shopper_name} no produto ${item.product_name}?`
            },
            event: "cancel-subscription"
          });
        }
      }
      return actions;
    },
    rePix() {
      window.axios
        .post(`/payment/re-pix/${this.itemToShow.id}`)
        .then(() => {
          this.$message.success("Pix reenviado com sucesso");
          this.modal.rePix = false;
        })
        .catch(() => {
          this.$message.error("Erro ao reenviar pix");
        });
    },
    installments(item) {
      if (item.current_install && item.installments) {
        return `${item.current_install}/${item.installments}`;
      } else if (item.installments) {
        return `${item.installments}x`;
      } else if (item.current_install) {
        return `${item.current_install}`;
      } else {
        return "-";
      }
    },
    allowRefund(item) {
      let refundable = ["paid", "completed"];
      return (
        moment().diff(moment(item.created_at), "day") <= 60 &&
        refundable.includes(item.status)
      );
    },
    openReceipt(item) {
      window.open(
        `https://api.blitzpay.com.br/v1/reports/${item.code}`,
        "_blank"
      );
    },
    showBillet(item) {
      this.modal.billet = true;
      this.itemToShow = item;
    },
    openRePix(item) {
      this.modal.rePix = true;
      this.itemToShow = item;
    },
    changeSubscription(item) {
      this.modal.changeSubscription = true;
      this.itemToShow = item;
    },
    tryAgain(item) {
      this.modal.retry = true;
      this.itemToShow = item;
    },
    openDetail(item) {
      this.$store.dispatch("sale/getSale", item.id).then(r => {
        this.$store.commit("sale/setSale", r);
        this.modal.details = true;
      });
    }
  }
};
